/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetSourceEnvironmentLinkRequestBody,
  SetSourceEnvironmentLinkRequestBody$Outbound,
  SetSourceEnvironmentLinkRequestBody$outboundSchema,
} from "../components/setsourceenvironmentlinkrequestbody.js";

export type SetSourceEnvironmentLinkSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SetSourceEnvironmentLinkRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  setSourceEnvironmentLinkRequestBody: SetSourceEnvironmentLinkRequestBody;
};

/** @internal */
export type SetSourceEnvironmentLinkSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetSourceEnvironmentLinkSecurity$outboundSchema: z.ZodMiniType<
  SetSourceEnvironmentLinkSecurity$Outbound,
  SetSourceEnvironmentLinkSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setSourceEnvironmentLinkSecurityToJSON(
  setSourceEnvironmentLinkSecurity: SetSourceEnvironmentLinkSecurity,
): string {
  return JSON.stringify(
    SetSourceEnvironmentLinkSecurity$outboundSchema.parse(
      setSourceEnvironmentLinkSecurity,
    ),
  );
}

/** @internal */
export type SetSourceEnvironmentLinkRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SetSourceEnvironmentLinkRequestBody:
    SetSourceEnvironmentLinkRequestBody$Outbound;
};

/** @internal */
export const SetSourceEnvironmentLinkRequest$outboundSchema: z.ZodMiniType<
  SetSourceEnvironmentLinkRequest$Outbound,
  SetSourceEnvironmentLinkRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    setSourceEnvironmentLinkRequestBody:
      SetSourceEnvironmentLinkRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      setSourceEnvironmentLinkRequestBody:
        "SetSourceEnvironmentLinkRequestBody",
    });
  }),
);

export function setSourceEnvironmentLinkRequestToJSON(
  setSourceEnvironmentLinkRequest: SetSourceEnvironmentLinkRequest,
): string {
  return JSON.stringify(
    SetSourceEnvironmentLinkRequest$outboundSchema.parse(
      setSourceEnvironmentLinkRequest,
    ),
  );
}
